import { useState } from 'react';
import { api } from '../lib/api';
import { fmtKstFull } from '../lib/time';

export default function SettingsPage() {
  const [token, setToken] = useState(localStorage.getItem('rhq_token') ?? '');
  const [base] = useState(import.meta.env.VITE_API_BASE ?? 'https://researchhq-api.tpark-works.workers.dev/api/v1');
  const [status, setStatus] = useState<string | null>(null);

  function save() {
    if (!token) {
      localStorage.removeItem('rhq_token');
      setStatus('토큰을 비웠습니다.');
      return;
    }
    localStorage.setItem('rhq_token', token);
    setStatus('저장됨. 다른 페이지에서 데이터가 로드됩니다.');
  }

  async function checkHealth() {
    try {
      const r = await api.health();
      setStatus(`✅ ${r.status} · v${r.version} · ${fmtKstFull(r.server_time)}`);
    } catch (e) {
      setStatus(`❌ ${e instanceof Error ? e.message : String(e)}`);
    }
  }

  return (
    <section>
      <h1 className="text-2xl font-semibold tracking-tight">설정</h1>
      <div className="mt-6 max-w-xl space-y-5 rounded-lg border border-slate-200 bg-white p-5">
        <div>
          <label className="block text-xs font-medium text-slate-700">API base URL</label>
          <input value={base} readOnly className="mt-1 block w-full rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5 font-mono text-xs" />
          <p className="mt-1 text-xs text-slate-500">
            변경하려면 build 시점 환경변수 <code>VITE_API_BASE</code>를 사용.
          </p>
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-700">API 토큰</label>
          <input
            type="password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="rhq_live_..."
            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-1.5 font-mono text-xs"
          />
          <p className="mt-1 text-xs text-slate-500">
            토큰은 브라우저 localStorage에만 저장됩니다. 서버로 전송되지 않습니다.
          </p>
        </div>
        <div className="flex gap-2">
          <button onClick={save} className="rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white">
            저장
          </button>
          <button onClick={checkHealth} className="rounded-md border border-slate-300 px-4 py-2 text-sm">
            health 체크
          </button>
        </div>
        {status && <p className="text-sm text-slate-700">{status}</p>}
      </div>
    </section>
  );
}
